/*
 * Module for duplicate vendor look up
*/

rs.module("ui/controls/duplicatevendorlookup",

    [],

    function () {

        var _jsSelectors;
        var _cssClasses;
        var _backendUrls;
        
        var _popup;

        var _onDuplicateSelectionCompleteHandler;
        var _getLookupParametersFunction;

        //
        // Initialize
        //
        function initialize(jsSelectors, cssClasses, backendUrls) {

            // unpack js selectors
            _jsSelectors = jsSelectors;
            _cssClasses = cssClasses;
            _backendUrls = backendUrls;

            _popup = $.js(_jsSelectors.popup);

            // hookup lookup link click event
            $.js(_jsSelectors.lookupLink).click(_lookupDuplicates);

            // Exported instance API
            return {
                onGetLookupParameters,
                onDuplicateSelectionComplete
            };
        }

        //
        // API function to allow consumers to tell this module where to pull lookup parameters from
        //
        function onGetLookupParameters(getLookupParametersFunction) {
            _getLookupParametersFunction = getLookupParametersFunction;
        }

        //
        // API function to allow consumers to specify a call back function to execute after duplicate selection is complete
        // This call back will return a vendorpartykey of the duplicate selected or -1 if it is a new vendor)
        //
        function onDuplicateSelectionComplete(onDuplicateSelectionComplete) {
            _onDuplicateSelectionCompleteHandler = onDuplicateSelectionComplete
        }

        //
        // Perform duplicate lookup
        //
        function _lookupDuplicates() {
            
            // get the parameters to perform the lookup
            var parameters = _getLookupParametersFunction.call();

            // only perform the lookup if the parameters object is not null
            if (parameters) {

                // Throw error if object returned from _getLookupParametersFunction doesn't have all necessary values
                if (!parameters.hasOwnProperty("vendorType") ||
                    !parameters.hasOwnProperty("firstName") ||
                    !parameters.hasOwnProperty("middleName") ||
                    !parameters.hasOwnProperty("lastName") ||
                    !parameters.hasOwnProperty("entityName") ||
                    !parameters.hasOwnProperty("tin") ||
                    !parameters.hasOwnProperty("fundKey")) {
                    throw "JSON object returned from onGetLookupParameters() requires properties: 'vendorType', 'firstName', 'middleName', 'lastName', 'entityName', 'tin', and 'fundKey'.";
                }

                // Show spinner
                $.js(_jsSelectors.ajaxSpinner).show();

                // perform lookup
                $.get(_backendUrls.duplicateLookup,
                    {
                        vendorType: parameters.vendorType,
                        firstName: parameters.firstName,
                        middleName: parameters.middleName,
                        lastName: parameters.lastName,
                        entityName: parameters.entityName,
                        tin: parameters.tin,
                        fundKey: parameters.fundKey
                    })
                    .done(function (result) {

                        if (result.noMatches) {
                            // since there were no matches, no need to show popup, just execute callback if it has been defined
                            if (_onDuplicateSelectionCompleteHandler) {
                                _onDuplicateSelectionCompleteHandler.call(_popup, -1);
                            }
                        }
                        else {
                            // display results inside the popup
                            _popup.js(_jsSelectors.lookupResults).html(result);

                            // widen the popup to show grid results
                            _popup.js(_jsSelectors.modalContent).addClass(_cssClasses.widePopup);

                            // show the popup 
                            _popup.modal("show");
                        }

                        // hide the spinner after lookup is complete
                        $.js(_jsSelectors.ajaxSpinner).hide();
                    });
            }
        }

        //
        // Initialize lookup results (called once _LookupResults.cshtml is rendered)
        //
        function initializeResults(jsSelectors, grid) {

            // listen for new vendor button clicks; call handler but send -1 for vendorPartyKey
            $.js(jsSelectors.newVendorButton, { required: false }).click(function () {
                if (_onDuplicateSelectionCompleteHandler) {
                    _onDuplicateSelectionCompleteHandler.call(_popup, -1);
                }
            });

            // listen for row selection in potential duplicates grid (if the grid was displayed)
            if (grid) {

                grid.selectionChanged(function (values, rows) {

                    // need to make sure values is greater than zero because grid.selectionChanged fires when grid is first rendered
                    if (values.length > 0) {

                        // call handler and send selected row's participantkey
                        if (_onDuplicateSelectionCompleteHandler) {
                            _onDuplicateSelectionCompleteHandler.call(_popup, values[0]);
                        }

                        _popup.modal("hide");
                    }
                });
            }
        }

        // Exported public API
        var exports = {
            initialize,
            initializeResults
        };

        return exports;
    }
);